import Vue from "vue";
// import "filepond-polyfill";
import App from "./App.vue";
import store from "./store";

import Classified from "./components/Classified.vue";

import VueRouter from "vue-router";

// var VueScrollTo = require("vue-scrollto");
import VueScrollTo from "vue-scrollto";
import VTooltip from "v-tooltip";

import config from "./config";

import "formdata-polyfill";
// import "custom-event-polyfill";
import "@babel/polyfill";
// import "filepond-polyfill/dist/filepond-polyfill.min";

import "filepond/dist/filepond.min.css";

import browserDetect from "vue-browser-detect-plugin";

import VueGtag from "vue-gtag";

var VueCookie = require("vue-cookie");

Vue.use(VueCookie);

Vue.use(browserDetect);

var numeral = require("numeral");
numeral.register("locale", "fr", {
  delimiters: {
    thousands: " ",
    decimal: ",",
  },
  abbreviations: {
    thousand: "k",
    million: "m",
    billion: "b",
    trillion: "t",
  },
  ordinal: function (number) {
    return number === 1 ? "er" : "ème";
  },
  currency: {
    symbol: "€",
  },
});
numeral.locale("fr");

Vue.use(VueScrollTo, {
  // container: "body",
  duration: 5,
  // easing: "ease",
  offset: -80,
  // force: true,
  // cancelable: true,
  // onStart: false,
  // onDone: false,
  // onCancel: false,
  // x: false,
  // y: true
});

Vue.use(VTooltip);

Vue.config.productionTip = true;

Vue.prototype.config = config;

Vue.mixin({
  methods: {
    // setStep
		isValidEmail(email) {
			return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
		},
    setStep(step) {
      this.$store.commit("setStep", step);
      if (!this.$store.state.is_admin) {
        router.push({
          name: "PA-etape-" + step,
          query: this.$route.query,
        });
        this.$gtag.pageview({
          page_title: this.$route.name,
          page_path: this.$route.path,
        });
      }
    },

    // PROFESSION TITLE
    professionTitle(profession) {
      return profession;
    },
    regionTitle(region_id) {
      let region = this.$store.state.settings.regions.find(
        (r) => r.term_id === region_id
      );
      if (region) return region.name;
      return "";
    },
    // NUMBER FORMAT
    numberFormat(number, options) {
      if (options === undefined) options = {};
      options = Object.assign(
        {
          nb_float: 2,
        },
        options
      );
      return numeral(number).format("0.00");
    },
    // SET MAX CONTENT LENGTH
    setMaxContentLength() {
      let length = 300;
      if (this.$store.state.classified.mode == "web") {
        length = 1500;
      } else {
        switch (this.$store.state.classified.format) {
          default:
          case "simple":
            length = 175;
            break;
          case "1/9":
            length = 300;
            break;
          case "2/9":
          case "3/9":
            length = 600;
            break;
          case "6/9":
            length = 1800;
            break;
          case "9/9":
            length = 2700;
            break;
        }
      }
      this.$store.commit("setMaxLength", length);
    },
    // SET MAX MEDIAS
    setMaxMedias() {
      if (false && this.$store.state.is_admin) {
        this.$store.commit("setMaxMedias", 9999);
      } else {
        if (this.$store.state.classified.mode == "web") {
          this.$store.commit("setMaxMedias", 10);
        } else {
          let medias = 1;
          switch (parseInt(this.$store.state.classified.format)) {
            default:
            case 1:
              medias = 1;
              break;
            case 2:
              medias = 2;
              break;
            case 3:
              medias = 3;
              break;
            case 6:
              medias = 6;
              break;
            case 9:
              medias = 9;
              break;
          }
          this.$store.commit("setMaxMedias", medias);
        }
      }
    },
    // CLASSIFIED PRICE
    getPrice(classified, options) {
      let price = 0;
      if (options === undefined) options = {};
      options = Object.assign(
        {
          tva: true,
          with_membership_discount: true,
          with_duration_discount: true,
          with_options: true,
          only_options: false,
          only_option: null,
          no_media: false,
          only_media: false,
					include_diff_abcdent: true,
        },
        options
      );

      let category = this.$store.state.categories.find(
        (cat) => cat.term_id == classified.category
      );

      if (classified.mode == "web") {
        if (classified.profil == "proflib") {
          if (category.free_category) {
            price = 0;
          } else {
            price = parseInt(
              this.$store.state.settings.formats.proflib.web.simple
            );
          }
        }
        if (classified.profil == "recruiter") {
          price = parseInt(
            this.$store.state.settings.formats.recruiter.web.simple
          );
        }
      }
      if (classified.mode == "print_web") {
        if (classified.profil == "proflib") {
          price = parseInt(
            this.$store.state.settings.formats.proflib.print_web[
              classified.format
            ]
          );
        }
        if (classified.profil == "recruiter") {
          price = parseInt(
            this.$store.state.settings.formats.recruiter.print_web[
              classified.format
            ]
          );
        }
      }

      let options_price = 0;
      switch (options.only_option) {
        case "background":
					price = this.$store.state.settings.options[classified.profil].option_background;
					break;
        case "urgent":
					price = this.$store.state.settings.options[classified.profil].option_urgent;
					break;
        case "move_top":
					price = this.$store.state.settings.options[classified.profil].option_move_top;
					break;
        case "domiciliation":
					price = this.$store.state.settings.options[classified.profil].option_domiciliation;
					break;
				case 'diff_abcdent':
					price = !options.include_diff_abcdent ? 0 : this.$store.state.settings.options[classified.profil]
					.option_diff_abcdent;
					break;
				case 'diff_abcdent_pro':
					price = !options.include_diff_abcdent ? 0 : this.$store.state.settings.options[classified.profil]
					.option_diff_abcdent_pro;
					break;
        case "media":
          if (classified.profil)
            price =
              this.$store.state.settings.options[classified.profil][
                "option_" + options.only_option
              ];
          break;
        default:
          if (!options.only_medias) {
            if (classified.option_background) {
              options_price += this.$store.state.settings.options[classified.profil].option_background;
						}

            if (classified.option_urgent) {
              options_price += this.$store.state.settings.options[classified.profil].option_urgent;
						}

            if (classified.option_move_top) {
              options_price += this.$store.state.settings.options[classified.profil].option_move_top;
						}

            if (options.include_diff_abcdent && classified.option_diff_abcdent) {
              options_price += this.$store.state.settings.options[classified.profil].option_diff_abcdent;
            }

            if (options.include_diff_abcdent && classified.option_diff_abcdent_pro) {
              options_price += this.$store.state.settings.options[classified.profil].option_diff_abcdent_pro;
            }

            if ( classified.option_domiciliation && classified.profil == "proflib" ) {
              options_price += this.$store.state.settings.options[classified.profil].option_domiciliation;
						}
          }

          if (!options.no_medias) {
            if (classified.medias.length && classified.format == "simple")
              options_price += classified.medias.length * this.$store.state.settings.options[classified.profil] .option_media;
          }

          if (options.only_options) {
            price = options_price;
          } else {
            if (options.with_options) {
              price += options_price;
            }
          }
          break;
      }

      price = price * parseInt(classified.duration);

      // if (classified.mode == "print_web")
      if (options.with_duration_discount) {
        let duration_discount = 1;
        duration_discount = this.durationDiscount(
          parseInt(classified.duration),
          classified
        );

        price = price * duration_discount;
      }

      if (options.with_membership_discount) {
        if (parseInt(classified.membership)) {
          price *= 1 - this.$store.state.settings.membership_discount / 100;
        }
      }

      if (!options.tva) {
        price /= 1 + this.$store.state.settings.tva / 100;
      }

      return price;
    },
    durationDiscount(n, classified, pct) {
      let duration_discount = 1;
      switch (n) {
        default:
          if (n >= 9) {
            duration_discount = 0.75; // https://tickets.bronx.fr/view.php?id=21964
            // duration_discount = classified.profil == "proflib" ? 0.75 : 0.8;
          }
          break;
        case 3:
        case 4:
          duration_discount = 0.9;
          break;
        case 5:
        case 6:
          duration_discount = 0.85;
          break;
        case 7:
        case 8:
          duration_discount = 0.8;
          break;
      }
      if (pct) return Math.round((1 - duration_discount) * 100);
      return duration_discount;
    },
    generateFakeClassified() {
      // if (process.env.NODE_ENV === "development") {
      //   var faker = require("faker");
      //   return {
      //     uniq_id: null,
      //     profil: Math.random() > 0.5 ? "proflib" : "recruiter",
      //     category: this.$store.state.categories[
      //       faker.random.number(this.$store.state.categories.length - 1)
      //     ].term_id,
      //     mode: Math.random() > 0.5 ? "print_web" : "web",
      //     format: Math.random() > 0.5 ? "simple" : "1/9",
      //     duration: faker.random.number(5) + " week",
      //     membership: faker.random.number(1),
      //     title: faker.lorem.sentence(),
      //     content: faker.lorem.sentences(5),
      //     profession: this.$store.state.settings.professions[
      //       faker.random.number(
      //         this.$store.state.settings.professions.length - 1
      //       )
      //     ].name,
      //     region: this.$store.state.settings.regions[
      //       faker.random.number(this.$store.state.settings.regions.length - 1)
      //     ].term_id,
      //     contact: faker.lorem.sentence(),
      //     medias: [],
      //     option_background: Math.random() > 0.5,
      //     option_move_top: Math.random() > 0.5,
      //     option_domiciliation: Math.random() > 0.5,
      //     option_urgent: Math.random() > 0.5,
      //   };
      // }
      return {};
    },
  },
});

const routes = [
  {
    path: config.app.url,
    component: Classified,
  },
  {
    path: config.app.url + "etape/1/",
    pathToRegexpOptions: { strict: true },
    component: Classified,
    name: "PA-etape-1",
    props: {
      step: "1",
    },
  },
  {
    path: config.app.url + "etape/2/",
    pathToRegexpOptions: { strict: true },
    component: Classified,
    name: "PA-etape-2",
    props: {
      step: "2",
    },
  },
  {
    path: config.app.url + "etape/3/",
    pathToRegexpOptions: { strict: true },
    component: Classified,
    name: "PA-etape-3",
    props: {
      step: "3",
    },
  },
  {
    path: config.app.url + "etape/confirmation/",
    pathToRegexpOptions: { strict: true },
    component: Classified,
    name: "PA-etape-confirmation",
    props: {
      step: "confirmation",
    },
  },
  {
    path: config.app.admin_url,
    component: Classified,
    props: {
      is_admin: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

Vue.use(VueGtag, {
  config: { id: "UA-46774263-1" },
  includes: [{ id: "G-L5MGG5C5KY" }],
});

Vue.use(VueRouter);

new Vue({
  store,
  router,
  el: "#classifieds-v2",
  render(h) {
    return h(App, {
      props: {
        create:
          this.$el.attributes.create ||
          document.location.hash.search("#create") == 0
            ? true
            : false,
        is_admin: this.$el.attributes.is_admin ? true : false,
        is_dev: this.$el.attributes.is_dev ? true : false,
      },
    });
  },
}); //.$mount("#classifieds-v2");
document.location.hash = "";
